// 前端定义的动态路由
const frontDynamicRouter = [
  {
    name: "虚拟仿真详情",
    path: "detail",
    parentPath: "simulation",
    component: () => import("@/views/simulation/simulationdetail/index.vue"),
    meta: { hidden: true },
  },
  {
    name: "虚拟仿真实验",
    path: "experiment",
    parentPath: "simulation",
    component: () => import("@/views/simulation/experiment/index.vue"),
    meta: { hidden: true },
  },
  {
    name: "虚拟仿真实验指导书",
    path: "GuideBookViewer",
    parentPath: "simulation",
    component: () => import("@/views/simulation/experiment/GuideBookViewer.vue"),
    meta: { hidden: true },
  },
  {
    name: "进入课程",
    path: "coursedetail",
    parentPath: "course",
    component: () => import("@/views/course/detail/index.vue"),
    meta: { hidden: true },
  },
  {
    name: "查看课程",
    path: "courseintroduce",
    parentPath: "course",
    component: () => import("@/views/course/introduce/index.vue"),
    meta: { hidden: true },
  },
  {
    name: "课程-大纲",
    path: "outline",
    parentPath: "coursedetail",
    component: () => import("@/views/course/detail/outline/index.vue"),
    meta: { hidden: true, icon: 'el-icon-s-operation' },
  },
  {
    name: "课程-资源",
    path: "resource",
    parentPath: "coursedetail",
    component: () => import("@/views/course/detail/resource/index.vue"),
    meta: { hidden: true, icon: 'el-icon-folder-opened' },
  },
  // {
  //   name: "导学",
  //   path: "leadlearning",
  //   parentPath: "coursedetail",
  //   component: () => import("@/views/course/detail/leadlearning/index.vue"),
  //   meta: { hidden: true, icon: 'el-icon-thumb' },
  // },
  {
    name: "考试",
    path: "examination",
    parentPath: "coursedetail",
    component: () => import("@/views/course/detail/examination/index.vue"),
    meta: { hidden: true, icon: 'el-icon-data-board' },
  },
  {
    name: "作业",
    path: "homework",
    parentPath: "coursedetail",
    component: () => import("@/views/course/detail/homework/index.vue"),
    meta: { hidden: true, icon: 'el-icon-coin' },
  },
  {
    name: "随堂测",
    path: "classroomtest",
    parentPath: "coursedetail",
    component: () => import("@/views/course/detail/classroomtest/index.vue"),
    meta: { hidden: true, icon: 'el-icon-tickets' },
  },
  {
    name: "讨论答疑",
    path: "discussionandqa",
    parentPath: "coursedetail",
    component: () => import("@/views/course/detail/discussionandqa/index.vue"),
    meta: { hidden: true, icon: 'el-icon-question' },
  },
  // {
  //   name: "收藏练习",
  //   path: "collectingexercises",
  //   parentPath: "coursedetail",
  //   component: () => import("@/views/course/detail/collectingexercises/index.vue"),
  //   meta: { hidden: true, icon: 'el-icon-thumb' },
  // },
  {
    name: "错题集",
    path: "wrongquestioncollection",
    parentPath: "coursedetail",
    component: () => import("@/views/course/detail/wrongquestioncollection/index.vue"),
    meta: { hidden: true, icon: 'el-icon-document-copy' },
  },
  {
    name: "虚拟仿真",
    path: "simulation",
    parentPath: "coursedetail",
    component: () => import("@/views/course/detail/simulation/index.vue"),
    meta: { hidden: true, icon: 'el-icon-data-line' },
  },
  {
    name: "知识图谱",
    path: "knowledgegraph",
    parentPath: "coursedetail",
    component: () => import("@/views/course/detail/knowledgegraph/index.vue"),
    meta: { hidden: true, icon: 'el-icon-share', openInNewTab: true },
    // meta: { hidden: true, icon: 'el-icon-share', openInNewTab: true, noLayout: true },
  },
  {
    name: "题目练习",
    path: "knowledgegraph/testquestions",
    parentPath: "/",
    component: () => import("@/views/course/detail/knowledgegraph/testquestions/index.vue"),
    meta: { hidden: true, noLayout: true },
  },
  // {
  //   name: "开始考试",
  //   path: "starttheexam",
  //   parentPath: "coursedetail",
  //   component: () =>
  //     import("@/views/course/detail/examination/starttheexam.vue"),
  //   meta: { hidden: true },
  // },
  {
    name: "咨询列表",
    path: "consultation",
    parentPath: "/",
    component: () => import("@/views/consultation/index.vue"),
    meta: { hidden: true },
  },
  {
    name: "咨询详情",
    path: "consultation/detail",
    parentPath: "/",
    component: () => import("@/views/consultation/detail.vue"),
    meta: { hidden: true },
  },
  {
    name: "AI 对话详情",
    path: "squareai/detail",
    parentPath: "/",
    component: () => import("@/views/squareai/detail/index.vue"),
    meta: { hidden: true, hideBottom: true },
  },
  {
    name: "AI 助手",
    path: "squareai/assistant",
    parentPath: "/",
    component: () => import("@/views/squareai/assistant/index.vue"),
    meta: { hidden: true, hideBottom: true },
  },
  {
    name: "AI 写作",
    path: "squareai/writing",
    parentPath: "/",
    component: () => import("@/views/squareai/writing/index.vue"),
    meta: { hidden: true, hideBottom: true },
  },
];

export default frontDynamicRouter;
